import {
  BASE_DEPTH as SHARED_BASE_DEPTH,
  WORLD_MIN_Y as SHARED_MIN_Y,
  WORLD_SIZE,
  WORLD_HEIGHT as SHARED_HEIGHT,
} from '@shared/protocol';

/** World dimensions in blocks. One block = 1 meter. */
export const WORLD_SIZE_X = WORLD_SIZE;
export const WORLD_SIZE_Z = WORLD_SIZE;
export const WORLD_HEIGHT = SHARED_HEIGHT;
export const WORLD_MIN_Y = SHARED_MIN_Y;
export const BASE_DEPTH = SHARED_BASE_DEPTH;

/** Horizontal chunk size and maximum block rendering radius. */
export const CHUNK_SIZE = 16;
export const BLOCK_RENDER_DISTANCE = 128;
export const BLOCK_RENDER_DISTANCE_CHUNKS = BLOCK_RENDER_DISTANCE / CHUNK_SIZE;

/** The white plate occupies y = 0, so the walkable surface is y = 1. */
export const GROUND_Y = 1;

export const BLOCK_AIR = 0;
export const BLOCK_WHITE = 1;
